module.exports = __webpack_public_path__ + "img/logo2x.2ddb0a1a.png";